import { forwardRef } from "react";
import { clsx } from "clsx";

import { Icon } from "../icon/Icon";

import type { IconProps } from "../icon/Icon";
import type { CommonProps } from "../components";

export interface TabProps extends CommonProps {
  children?: React.ReactNode;
  count?: number;
  icon?: IconProps["icon"];
  notification?: boolean;
  onClick?: (e: React.SyntheticEvent) => void;
}

export const Tab = forwardRef<HTMLButtonElement, TabProps>(function Tab(
  { children, className, count, icon, notification, onClick, ...rest },
  ref,
) {
  const scrollIntoView = (element: Element) => {
    // Allow the browser to paint before scrolling
    requestAnimationFrame(() => {
      element.scrollIntoView({
        block: "nearest",
        inline: "center",
        behavior: "smooth",
      });
    });
  };

  const handleFocus = (e: React.FocusEvent) => {
    scrollIntoView(e.target);
  };

  return (
    <button
      className={clsx("Tab", className)}
      tabIndex={-1}
      ref={ref}
      role="tab"
      onClick={onClick}
      onFocus={handleFocus}
      {...rest}
    >
      {icon && <Icon icon={icon} size="md" />}
      {children}
      {count != null && <span className="Tab-count">{count}</span>}
      {notification && <span className="Tab-notification" />}
    </button>
  );
});
